import axios from '@fs/zion-axios'
import useFetchData from './useFetchData'
import useStateManager from './useStateManager'
import getIdentBaseUrl from '../utils/getIdentBaseUrl'

const fetchJurisdictions = async () => {
  const { data } = await axios.get(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/jurisdictions`)
  return data?.jurisdictions ?? []
}

const updateJurisdictions = (jurisdictions) =>
  Promise.all(
    jurisdictions.map(({ jurisdiction, doesApply }) =>
      axios.post(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/jurisdictions`, {
        jurisdiction,
        doesApply,
      })
    )
  )

export default function useJurisdictions() {
  const { data: remoteJurisdictions, loading: jurisdictionsLoading } = useFetchData(fetchJurisdictions, {
    initialData: [],
  })
  const { state: localJurisdictions, handleChangeState: handleChangeJurisdictions } =
    useStateManager(updateJurisdictions)
  const jurisdictions = localJurisdictions ?? remoteJurisdictions
  return { jurisdictions, jurisdictionsLoading, handleChangeJurisdictions }
}
